"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLTIP_STYLES = void 0;
var TOOLTIP_STYLES = exports.TOOLTIP_STYLES = {
  RATING: {
    padding: '0',
    color: 'inherit',
    textAlign: 'unset',
    backgroundColor: 'inherit',
    borderRadius: 'initial',
    border: 'none'
  }
};